import { get } from '../..';

const getSpaces = (parentLocationId: string) => get(`locations/space?ParentId=${parentLocationId}`);

export default getSpaces;
